import { render } from "./MeuPerfil.vue?vue&type=template&id=d6232646&scoped=true"
import script from "./MeuPerfil.vue?vue&type=script&lang=js"
export * from "./MeuPerfil.vue?vue&type=script&lang=js"

import "./MeuPerfil.vue?vue&type=style&index=0&id=d6232646&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6232646"]])

export default __exports__